import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    selectedUnitIds: null, // 选中的科室
    keyword: "", // 搜索关键词
    pageable: {
        current: 1,
        limit: 30,
    },
    datePicker: {
        beginDate: null, // datepicker开始时间
        endDate: null, // datepicker结束时间
    },

    data: null, // 表格数据
    tableLoading: false,

    reviewDrawerVisible: false, // 评价drawer可见
    editDrawerVisible: false, // 编辑添加可见
    editData: null, // 编辑数据
    updating: false, // 数据更新中

    reviewFormTemplate: null, // 借调评价模板
    reviewFormId: null, // 评价表格id
    itemFormLoading: false, // 点击中的数据评价模板加载
    itemReviewFormTemplate: null, // 点击中的数据评价模板
}

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
